import React from 'react';

import { useTranslation } from 'react-i18next';

import { Modal, Button, Form, Input } from 'antd';

const formLayout = {
	labelCol: { span: 24 },
	wrapperCol: {
		span: 24,
	},
};

export const OptionEditionModal = (props: any) => {
	const [form] = Form.useForm();
	const { t } = useTranslation();

	const handleFormSubmit = () => {
		console.log('handleFormSubmit');
		form.validateFields()
			.then((values) => {
				console.log('validated', values);
				props.onSave(values);
				props.onHide();
			})
			.catch((errorInfo) => {
				console.log('error', errorInfo);
			});
	};

	const footer = (
		<div style={{ display: 'flex' }}>
			{props.onDelete && <Button
				onClick={() => {
					props.onDelete(props);
				}}
				danger={true}
				style={{ marginRight: 'auto' }}
			>
				Delete
			</Button>}
			<Button
				className='ml-auto'
				onClick={() => {
					props.onHide();
				}}
			>
				Cancel
			</Button>
			<Button onClick={handleFormSubmit} type="primary" className="ml-1">
				Save
			</Button>
		</div>
	);

	return (
		<Modal
			visible={true}
			title={props.id ? t('models.option.form.edition.title') : t('models.option.form.creation.title')
			}
			okButtonProps={{ style: { display: 'none' } }}
			onCancel={props.onHide}
			cancelText="Close"
			footer={footer}
			width={"calc( min(100%, 800px) )"}
		>
			<Form
				{...formLayout}
				form={form}
				onFinish={() => {
					props.onHide();
				}}
				initialValues={props.values}
			>
				<Form.Item name="name" label="Name">
					<Input></Input>
				</Form.Item>
				<Form.Item name="description" label={t('models.option.fields.description')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
				<Form.Item name="evaluation" label={t('models.option.fields.evaluation')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
				<Form.Item name="comments" label={t('models.option.fields.comments')}>
					<Input.TextArea rows={6}></Input.TextArea>
				</Form.Item>
			</Form>
		</Modal >
	);
};

export default OptionEditionModal;
